import { getFirm, addFirm, createFirm } from "../../utils/api";
import { START_LOADING, END_LOADING } from "./loading_actions";
import { SET_PORTAL_API } from "./portal_actions";
import { TITLE_ERROR } from "../../utils/constants";
import { REQUEST_GET_FIRMS_SUCCESS } from "./firms_actions";

export const EDIT_INN = 'EDIT_INN';
export const EDIT_NAME = 'EDIT_NAME';
export const EDIT_SHORT_NAME = 'EDIT_SHORT_NAME';
export const EDIT_OGRN = 'EDIT_OGRN';
export const EDIT_KPP = 'EDIT_KPP';
export const EDIT_RASS_SCHET = 'EDIT_RASS_SCHET';
export const EDIT_BANK_NAME = 'EDIT_BANK_NAME';
export const EDIT_BIK = 'EDIT_BIK';
export const EDIT_KORR_SCHET = 'EDIT_KORR_SCHET';
export const EDIT_DIRECTOR_NAME = 'EDIT_DIRECTOR_NAME';
export const EDIT_DIRECTOR_FOOTING = 'EDIT_DIRECTOR_FOOTING';
export const EDIT_DIRECTOR_POST = 'EDIT_DIRECTOR_POST';
export const EDIT_ADRESS = 'EDIT_ADRESS';
export const EDIT_EMAIL = 'EDIT_EMAIL';
export const EDIT_DEFAULT_DEF_PAYMENT = 'EDIT_DEFAULT_DEF_PAYMENT';
export const CLEAR_FIRM_FORM = 'CLEAR_FIRM_FORM';
export const CLEAR_FIRM_FORM_EXCEPT_INN = 'CLEAR_FIRM_FORM_EXCEPT_INN';
export const CLEAR_FOUND_FIRM = 'CLEAR_FOUND_FIRM';
export const SET_VALID_FORM = 'SET_VALID_FORM';

export const REQUEST_GET_FIRM_SUCCESS = 'REQUEST_GET_FIRM_SUCCESS';
export const REQUEST_GET_FIRM_FAILED = 'REQUEST_GET_FIRM_FAILED';

export const REQUEST_ADD_FIRM_SUCCESS = 'REQUEST_ADD_FIRM_SUCCESS';
export const REQUEST_ADD_FIRM_FAILED = 'REQUEST_ADD_FIRM_FAILED';

export const REQUEST_CREATE_FIRM_SUCCESS = 'REQUEST_CREATE_FIRM_SUCCESS';
export const REQUEST_CREATE_FIRM_FAILED = 'REQUEST_CREATE_FIRM_FAILED';


export const getFirmByInnThunk = (accessToken, refreshToken, inn) => {
  return function (dispatch) {
    dispatch({ type: START_LOADING });
    getFirm(accessToken, refreshToken, inn)
      .then(data => {
        if (Array.isArray(data) && data.length > 0) {
          dispatch({
            type: REQUEST_GET_FIRM_SUCCESS,
            payload: data[0]
          });
          dispatch({ type: EDIT_NAME, name: data[0].name });
          dispatch({ type: EDIT_SHORT_NAME, short_name: data[0].short_name });
          dispatch({ type: EDIT_OGRN, ogrn: data[0].ogrn });
          dispatch({ type: EDIT_KPP, kpp: data[0].kpp });
          dispatch({ type: EDIT_RASS_SCHET, rass_schet: data[0].rass_schet });
          dispatch({ type: EDIT_BANK_NAME, bank_name: data[0].bank_name });
          dispatch({ type: EDIT_BIK, bik: data[0].bik });
          dispatch({ type: EDIT_KORR_SCHET, korr_schet: data[0].korr_schet });
          dispatch({ type: EDIT_DIRECTOR_NAME, director_name: data[0].director_name });
          dispatch({ type: EDIT_ADRESS, adress: data[0].adress });
          dispatch({ type: EDIT_EMAIL, email: data[0].email });
          dispatch({ type: SET_VALID_FORM, valid_form: true });
          dispatch({ type: EDIT_DIRECTOR_FOOTING, director_footing: data[0].director_footing });
          dispatch({ type: EDIT_DIRECTOR_POST, director_post: data[0].director_post });
          dispatch({ type: EDIT_DEFAULT_DEF_PAYMENT, default_def_payment: data[0].default_def_payment });
        } else {
          dispatch({
            type: REQUEST_GET_FIRM_SUCCESS,
            payload: {}
          });
          dispatch({ type: CLEAR_FIRM_FORM_EXCEPT_INN });
          dispatch({ type: SET_VALID_FORM, valid_form: false });
        }
      })
      .catch(error => {
        dispatch({ type: REQUEST_GET_FIRM_FAILED });
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}

export const postAddFirmThunk = (accessToken, refreshToken, navigate, inn, user_id, from = null) => {
  return function (dispatch) {
    dispatch({ type: START_LOADING });

    return addFirm(accessToken, refreshToken, inn, user_id)
      .then(data => {
        dispatch({ type: REQUEST_GET_FIRMS_SUCCESS, payload: data });
        if (from === '/new_order') {
          navigate('/new_order', { state: { from } });
        } else {
          navigate('/profile/firms', { replace: true });
        }
        dispatch({ type: CLEAR_FIRM_FORM });
      })
      .catch(error => {
        dispatch({ type: REQUEST_ADD_FIRM_FAILED });
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: CLEAR_FIRM_FORM });
        dispatch({ type: END_LOADING });
      });
  }
}


export const postCreateFirmThunk = (accessToken, refreshToken, navigate, data, user_id, from = null) => {
  return function (dispatch) {
    dispatch({ type: START_LOADING });
    return createFirm(accessToken, refreshToken, data, user_id)
      .then(data => {
        dispatch({ type: REQUEST_CREATE_FIRM_SUCCESS, payload: data });
        if (from === '/new_order') {
          navigate('/new_order', { state: { from } });
        } else {
          navigate('/profile/firms', { replace: true });
        }
      })
      .catch(error => {
        dispatch({ type: REQUEST_CREATE_FIRM_FAILED });
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}
